import { AuthEffects } from './../../../auth/state/auth.effects';
import { Injectable } from '@angular/core';
import { HelpTextService } from './help-text.service';
import { HelpText, HelpTextBody, HelpTextFooter, HelpTextHeader } from '../model/helpText.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { AccessService } from 'src/app/component/navigation/service/access.service';

@Injectable({
    providedIn: 'root'
})
export class HelpTextStorageService {
    helpTexts: { [id: string]: BehaviorSubject<HelpText>} = {};
   //helpTextsAll: { [id: string]: HelpText } = {};
    public helpTextsAllSubject = new BehaviorSubject< { [id: string]: HelpText}>({
            /* 'id': '',
            'routeUrls': [],
            'header': {},
            'bodies': [],
            'footer': {},
            'createdBy': '',
            'createdDate': '',
            'modifiedBy': '',
            'modifiedDate': '' */
    });
    //helpTextsAll$ = this.helpTextsAllSubject.asObservable();

    observables: { [id: string]: Observable<HelpText>} = {};
    queueIds: string[] = [];
    timeout: any;
    hasPermission: boolean;

    constructor(private helpTextService: HelpTextService, 
                public accessService: AccessService, 
                private authEffects: AuthEffects) {
        this.authEffects.isLoggedIn$.subscribe((isLoggedIn) => {
            if (isLoggedIn) {
                this.hasPermission = this.accessService.verifyUserRole('System Administrator');
            }
        });
    }

    getHelpText(id: string): Observable<HelpText> {
        //console.log("help-text-storage.service getHelpText() called for one individual helpTextId:")
        //console.log(id)

        if (!this.queueIds.includes(id))
        {
            this.queueIds.push(id);
        }
        this.helpTexts[id] = new BehaviorSubject<HelpText>(new HelpText());
        this.observables[id] = this.helpTexts[id].asObservable();

        this.getHelpTexts(1000);                

        return this.observables[id];
    }

    updateHelpText(ht: HelpText) {
        if (this.helpTexts[ht.id]) {
            this.helpTexts[ht.id].next(ht);
        }
    }
    
    updateHelpTextsAllSubject(ht: HelpText)
    {
        const htAll = {...this.helpTextsAllSubject.value, [ht.id]: ht };
        this.helpTextsAllSubject.next(htAll);
    }

    getHelpTexts(milliseconds: number) {
        //console.log("help-text-storage.service getHelpTexts called");
        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        this.timeout = setTimeout(() => {
       
            const helpTextQueueIds = (this.queueIds.length > 1)
                ? this.queueIds.join(',')
                : this.queueIds[0] || '';
            this.helpTextService.getHelpTexts(helpTextQueueIds).subscribe((helpTexts: HelpText[]) => {
                if (helpTexts) {
                     //console.log("storage services has helpTexts as:")
                     //console.log(helpTexts)
                     //console.log("length of helpTexts:")
                     //console.log(helpTexts.length)
                

                    for (let helpText of helpTexts) {

                        //console.log("For one helptextid, we are sending helpText:", helpText);
                        if (helpText)
                        {
                            const helpTextSubject = this.helpTexts[helpText.id];
                            if (helpTextSubject && typeof helpTextSubject.next === "function") {
                                try
                                {
                                    this.helpTexts[helpText.id].next(helpText);                   
                                }
                                catch (errInvalidProperties)
                                {
                                    console.log("found invalid property in:", helpText,":",errInvalidProperties);
                                }
                            }
                            else {
                                console.log("helpTexts[helpText.id] is undefined or does not have a .next() method for id:", helpText.id);
                            }
                        }
                        // Remove from queue
                        this.queueIds = this.queueIds.filter((id) => id !== helpText.id);
                    }
   
                    // Attempt to create empty helpTexts w/ remaining ids
                    // if (this.hasPermission) {
                    //     if (this.queueIds.length > 0) {
                    //         this.createEmptyHelpTexts(this.queueIds);
                    //     }
                    //  }
                }

                this.queueIds = [];
            });
        }, milliseconds);
    }

    createEmptyHelpTexts(helpTextIds: string[]) {
        if (this.hasPermission) {
            let promises = [];
            for (let id of helpTextIds) {
                let newHelpText = new HelpText();
                newHelpText.id = id;
                newHelpText.createdBy = 'System';
                newHelpText.header = new HelpTextHeader();
                newHelpText.footer = new HelpTextFooter();

                newHelpText.routeUrls = [];

                newHelpText.bodies = [];
                newHelpText.bodies.push(new HelpTextBody());

                let deferred = new Promise((resolve, reject) => {
                    this.helpTextService.createUpdate(newHelpText).subscribe((res) => {
                        resolve(res);
                    });
                });
                promises.push(deferred);
            }

            Promise.all(promises).then((res) => {
                this.helpTextService.getHelpTexts(helpTextIds.join(',')).subscribe((helpTexts: HelpText[]) => {
                    //console.log("new promise has helpTexts as:")
                    //console.log(helpTexts)
                    if (helpTexts) {
                        for (let helpText of helpTexts) {
                            this.helpTexts[helpText.id].next(helpText);
                        }
                    }
                });
            });
        }
    }
}
